import React, { useEffect, useState } from "react";
import Header from "./Header";
import CustomModal from "../CustomModal";
import { useNavigate } from "react-router-dom/dist";
import bannerimage from "../Assets/tie-banner.webp";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Footer from "./Footer";
import star from "../Assets/star.webp";
import trust from "../Assets/trust.webp";
import googleStar from "../Assets/googleStar.webp";
import google from "../Assets/google.webp";
import axios from "axios";
import DupModal from "../DupModal";

const Optin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.fbq("track", "Lead");
  }, []);

  const [addModel, setAddModel] = useState(false);
  const [dupModel, setdupModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [create, SetCreate] = useState({});
  const [validation, setValidation] = useState({});

  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!create.Name) {
      validdateData.Name = "Name is Required";
      Status = false;
    }
    if (!create.Email) {
      validdateData.Email = "Email is Required";
      Status = false;
    }
    if (!create.Number) {
      validdateData.Number = "Number is Required";
      Status = false;
    } else if (create.Number.length < 10) {
      validdateData.Number = "Invalid Number";
      Status = false;
    }
    if (!create.Location) {
      validdateData.Location = "Location is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };

  const setData = (e, key) => {
    SetCreate({ ...create, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  // const handleSubmit = async (e) => {
  //   setLoading(true);
  //   e.preventDefault();
  //   const Payload = [
  //     {
  //       Attribute: "FirstName",
  //       Value: create.Name,
  //     },
  //     {
  //       Attribute: "EmailAddress",
  //       Value: create.Email,
  //     },
  //     {
  //       Attribute: "Phone",
  //       Value: create.Number,
  //     },
  //     {
  //       Attribute: "mx_City",
  //       Value: create.Location,
  //     },
  //     {
  //       Attribute: "Source",
  //       Value: "Optin",
  //     },
  //   ];

  //   if (CheckValidation()) {
  //     try {
  //       const response = await axios.post(
  //         "https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.Capture?accessKey=u$r6bb21b3cf1518343d1981ce6646b844f&secretKey=d58ccce3a29496917e48f84d2f40d31061c6b781",
  //         Payload,
  //         {
  //           headers: {
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       if (response.data.Status === "Error") {
  //         alert("check");
  //       } else if (response.data.Status === "Success") {
  //         setLoading(false);
  //         setAddModel(false);
  //         setTimeout(() => {
  //           if (response.data.Status === "Success") {
  //             navigate("./Masterclass");
  //           } else {
  //             navigate("/");
  //           }
  //         }, 500);
  //       } else {
  //         setLoading(false);
  //         setButtonDisabled(true);
  //       }
  //     } catch (e) {
  //       setLoading(false);
  //       setButtonDisabled(false);
  //       // setdupModel(true);
  //       navigate("./Masterclass");
  //       console.log(e, "error");
  //     }
  //   } else {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (CheckValidation()) {
      let inputvalue = {
        FirstName: create.Name,
        EmailAddress: create.Email,
        Phone: create.Number,
        mx_City: create.Location,
        Source: "Optin",
        Date: new Date(),
        // Location: window.location.href,
      };
      console.log(inputvalue, "inputvalue");
      let formdataToSend = new FormData();
      for (let key in inputvalue) {
        formdataToSend.append(key, inputvalue[key]);
      }

      try {
        await axios.post(
          "https://script.google.com/macros/s/AKfycbyBXviVMtqMFTH4FFTmZbQwaPk3WaeBmMthloR5unBiWPqY1g9x4GXmcYsz3ooimEJmQw/exec",
          formdataToSend
        );
        setLoading(false);
        setAddModel(false);
        setTimeout(() => {
          navigate("./Masterclass");
        }, 500);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <Header />
      <section>
        <div className="mt-md-4">
          <div className="mb-4 py-3">
            <h4 className="text-center fw-bold atten-section mb-0">
              Attn: Business Owners Making ₹2Cr+ Per Year – Struggling to Scale
              Beyond?
            </h4>
          </div>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-11">
                <h1 className="title">
                  If You’re Stuck at ₹2Cr, It’s Not a{" "}
                  <span className="parahighlight"> Sales Problem</span>, It’s a{" "}
                  <span className="parahighlight"> Systems Problem</span>{" "}
                </h1>
                <h1 className="subsubtitle pt-3">
                  (Most business owners hit a plateau at ₹2Cr revenue because
                  they rely too much on {" "}
                  <span className="parahighlight"> hustle instead of structured systems and
                  processes.</span>{" "} Scaling to ₹10Cr+ isn’t about working harder—it’s
                  about {" "}
                  <span className="parahighlight">fixing operational bottlenecks, optimizing workflows,
                  and building a business that runs without you.</span>)
                </h1>
                <h3 className="text-center fw-bold  text-decoration-underline pt-3 mb-0">
                Watch this free masterclass to unlock your next stage of business growth.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6">
              <img
                src={bannerimage}
                alt="Social Eagle"
                className="bannerimage"
                onClick={() => setAddModel(true)}
              />
            </div>
            <div className="col-lg-6">
              <p className="para col_head fs-3">What Will You Learn</p>
              <p className="subpara">
                <span className="line">
                  <span className="icon">✔ </span>
                  How to make critical decisions without feeling isolated and
                  scale you business faster?
                </span>
                <br />
                <span className="line">
                  <span className="icon">✔ </span>
                  Create a string second line in your business.
                </span>
                <br />
                <span className="line">
                  <span className="icon">✔ </span>
                  Hire and retain the right team members.
                </span>
                <br />
                <span className="line">
                  <span className="icon">✔ </span>
                  How to gain business transformation using personal
                  transformation
                </span>
                <br />
                <span className="line">
                  <span className="icon">✔ </span>
                  How to get honest feedback on your business and get
                  non-judgemental support
                </span>
                <br />
                <span className="line">
                  <span className="icon">✔ </span>
                  How to access proven strategies and insights?
                </span>
                <br />
                <span className="line">
                  <span className="icon">✔ </span>
                  And many more...
                </span>
              </p>

              <div className="alignment">
                <button className="button" onClick={() => setAddModel(true)}>
                  Watch Now For FREE
                </button>
                {/* <div className="row">
                  <div className="col-md-8 mx-auto ms-auto">
                    <div className="row mt-3 justify-content-center align-items-center gy-lg-2 gy-5">
                      <div className="col-md-3 col-6 p-0">
                        <div className="alignment">
                          <img src={star} alt="Star" className="starimage" />
                        </div>
                      </div>
                      <div className="col-md-3 col-6 p-0">
                        <img src={trust} alt="Star" className="trustimage" />
                      </div>
                      <div className="col-md-3 col-6 p-0">
                        <div className="alignment">
                          <img
                            src={googleStar}
                            alt="Star"
                            className="starimage"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 col-6 p-0">
                        <img src={google} alt="Star" className="trustimage" />
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  addModel */}
      <CustomModal
        open={addModel}
        onClickOutside={() => {
          setAddModel(false);
        }}
      >
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="modal-content  m-auto">
            <div className=" text-center mt-5">
              <h6 className="titlemodel">Watch Now For FREE!</h6>
              <p className="paramodel">
                Enter your info, start watching the&nbsp;
                <span className="parahighlighttext">MASTERCLASS</span>&nbsp;
                immediately
              </p>
            </div>
            <div className="modal-body p-0 ">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container">
                    <div className="mt-4">
                      <input
                        type="text"
                        className="inputbox"
                        placeholder="Enter Your Full Name*"
                        defaultValue={create.Name}
                        onChange={(e) => {
                          setData(e.target.value, "Name");
                        }}
                      />
                      {validation.Name && (
                        <p className="validationmsg">{validation.Name}</p>
                      )}
                    </div>
                    <div className="mt-4">
                      <PhoneInput
                        country={"in"}
                        placeholder="Enter Your Mobile Number"
                        autoComplete="off"
                        onChange={(e) => {
                          setData(e, "Number");
                        }}
                        defaultValue={create.Number}
                      />
                      {validation.Number && (
                        <p className="validationmsg">{validation.Number}</p>
                      )}
                    </div>
                    <div className="mt-4">
                      <input
                        type="text"
                        className="inputbox"
                        placeholder="Enter Your Email Address*"
                        defaultValue={create.Email}
                        onChange={(e) => {
                          setData(e.target.value, "Email");
                        }}
                      />
                      {validation.Email && (
                        <p className="validationmsg">{validation.Email}</p>
                      )}
                    </div>
                    <div className="mt-4">
                      <input
                        type="text"
                        className="inputbox"
                        placeholder="Enter Your City*"
                        defaultValue={create.Location}
                        onChange={(e) => {
                          setData(e.target.value, "Location");
                        }}
                      />
                      {validation.Location && (
                        <p className="validationmsg">{validation.Location}</p>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="modelbutton"
                      disabled={buttonDisabled || loading}
                    >
                      Watch Now For FREE!
                      {loading ? (
                        <i className="fa fa-circle-o-notch fa-spin"></i>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setAddModel(false);
                  }}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>
      <DupModal
        open={dupModel}
        onClickOutside={() => {
          setdupModel(false);
        }}
      >
        <div className="modal-content  m-auto">
          <div className=" text-center mt-5">
            <h6 className="titlemodel">Hi Again !!!</h6>
            <p className="paramodel">
              We have found that your contact information already available in
              our system.
            </p>
          </div>
          <div className="modal-body p-0 ">
            <div className="container">
              <div className="row d-flex align-items-center justify-content-center  mt-0">
                <div className="container">
                  <button
                    type="submit"
                    className="modelbutton"
                    onClick={() => {
                      setdupModel(false);
                    }}
                  >
                    Okay!!! Sure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DupModal>
      <Footer />
    </>
  );
};

export default Optin;
